/**
 * Copyright © Smartex Canada All rights reserved.
 * See LICENSE for license details.
 */

import { getTemplate, getTemplateChildren } from "@/utils/dom/component";

let loaderTemplate: HTMLTemplateElement;

export class Loader {
    static readonly templateSelector = 'global-loader';

    public visible: boolean = false;
    private element: HTMLElement;
    private wasCreated: boolean = false;
    private wasHidden: boolean = false;

    constructor(options: LoaderOptions = {}) {
        if (!loaderTemplate) {
            loaderTemplate = getTemplate(Loader.templateSelector) || this._createTemplate();
        }

        if (options.element) {
            this.element = options.element;
            this.element.style.display = 'none';
            this.wasHidden = this.element.classList.contains('hidden');
            this.element.classList.remove('hidden');
        }
        else {
            this.wasCreated = true;
            this.element = getTemplateChildren(options.template || loaderTemplate)[0];
            this.element.style.display = 'none';
            (options.appendTo || document.body).append(this.element);
        }
    }

    /**
     * Destroy instance
     */
    public destroy(): void {
        this.hide();

        if (this.wasCreated) {
            this.element.remove();
        } else {
            this.element.classList.toggle('hidden', this.wasHidden);
        }

        this.element = null as any;
    }

    /**
     * Show the loader
     */
    public show(): void {
        this.visible = true;
        document.body.style.overflow = 'hidden';
        this.element.style.display = '';
    }

    /**
     * Hide the loader
     */
    public hide(): void {
        this.element.style.display = 'none';
        document.body.style.overflow = '';
        this.visible = false;
    }

    /**
     * Create loader template
     */
    private _createTemplate() {
        const template = document.createElement('template');
        const loader = document.createElement('div');
        const text = document.createElement('span');

        text.textContent = window.themeConfig.i18n.loading || 'Loading...';
        text.classList.add('loader__text');

        loader.classList.add('loader');
        loader.style.display = 'none';
        loader.append(text);

        template.content.append(loader);
        return template;
    }
}

export interface LoaderOptions {
    template?: HTMLTemplateElement | null
    element?: HTMLElement | null
    appendTo?: HTMLElement
}
